import { getWithToken } from 'api/network';
import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  fetchAssumptionModules,
  setModules,
  setModulesAreLoading,
} from '../../../store/actions';

export function* getAssumptionModulesSaga() {
  yield takeEvery(fetchAssumptionModules, function* () {
    try {
      yield put(setModulesAreLoading(true));

      const url = '/api/assumptions/modules';
      const res = yield getWithToken(url);
      const data = yield res.json();

      yield put(setModules(data));
      yield put(setModulesAreLoading(false));
    } catch (error) {
      yield put(
        appNotify(
          `Failure in getAssumptionModulesSaga: ${error.message}`,
          'error'
        )
      );
      yield put(setModulesAreLoading(false));
    }
  });
}
